import { Localized } from "@fluent/react";
import {
	Table,
	TableHead,
	TableRow,
	TableBody,
	TableCell,
	Button,
	Box,
} from "@mui/material";
import { UserHealth } from "../../types/model";
import { ParcialUser } from "../../types/apiv1";
import Title from "./Title";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import AlarmGroupUserAdder from "../logic/AlarmGroupUserAdder";
import GridUI from "./GridUI";
import AppConnected from "../logic/AppConnected";
import { useEffect, useState } from "react";
import { useAPI } from "../../apiv1";

interface AlarmGroupProps {
	name: string;
	members: ParcialUser[];
	membersHealth: UserHealth[];
	organizationID: string;
	alarmGroupID: string;
	removeUserFromAlarmGroup: (id: string) => void;
}

function useAssignableUsers(organizationID: string, alarmGroupID: string) {
	// TODO: error handling
	const api = useAPI();
	const [assignableUsers, setAssignableUsers] = useState<ParcialUser[]>([]);

	useEffect(() => {
		(async () => {
			const assignablUsers = await api.organizations.id(organizationID).alarmgroups.id(alarmGroupID).assignable();
			setAssignableUsers(assignablUsers);
		})();
	}, [organizationID, alarmGroupID, api, setAssignableUsers]);

	return assignableUsers;
}

export default function AlarmGroupUI(props: AlarmGroupProps) {
	const assignableUsers = useAssignableUsers(props.organizationID, props.alarmGroupID);
	
	function handleClick(id: string) {
		props.removeUserFromAlarmGroup(id);
	}
	
	console.log("members: ", props.members)

	return (
		<GridUI
			item xs={12}
		>
			<Box
				sx={{ 
					display: "flex", 
					alignItems: "stretch", 
					justifyContent: "space-between",
				}}
			>
				<Title>{props.name}</Title>
			</Box>
			
			<Box
			sx={{
				paddingTop: 4,
				paddingBottom: 2,
			}}
			>
				<AlarmGroupUserAdder
					alarmGroupID={props.alarmGroupID}
					assignableUsers={assignableUsers}
				/>
			</Box>
			

			<Table size="small">
				<TableHead>
					<TableRow>
						<Localized id="alarm-group-list-table-head-name">
							<TableCell></TableCell>
						</Localized>
						<Localized id="alarm-group-list-table-head-app-connected">
							<TableCell></TableCell>
						</Localized>
						<Localized id="alarm-group-list-table-head-app-remove-user">
							<TableCell></TableCell>
						</Localized>
					</TableRow>
				</TableHead>
				<TableBody>
					{props.members.map((user) => (
						<TableRow key={user.user_id}>
							<TableCell>
								{user.given_name} {user.family_name}
							</TableCell>
							<TableCell>
								<AppConnected userHealth={
									props.membersHealth.find(userHealth => userHealth.user_id === user.user_id)} />
							</TableCell>
							<TableCell>
								<Localized id="alarm-group-list-table-head-app-remove-user">
									<Button
										type="submit"
										variant="outlined"
										startIcon={<PersonRemoveIcon />}
										onClick={() => handleClick(user.user_id)}
									>
										{/* Localized */}
									</Button>
								</Localized>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</GridUI>
	);
}
